// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"b832b13d","145":"e703c2c5","236":"8f49346e","388":"33611f65","439":"63d5275e","447":"14355797","518":"05cd463a","592":"f5b8fea4","659":"4c219b81","932":"2d57bb18"}[chunkId] + ".chunk.js";
};